export default __webpack_public_path__ + "static/media/tara-tea.ca51f89f.jpg";